import { Link } from "react-router-dom";
import { Twitter, Github, Linkedin, Instagram } from "lucide-react";
import { DwinovLogo } from "./DwinovLogo";

const Footer = () => {
  return (
    <footer className="border-t border-warm-200 bg-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Link to="/" className="inline-flex items-center">
              <DwinovLogo size={40} />
            </Link>
            <p className="mt-4 text-sm text-navy-500 max-w-sm">
              Launch ideas. Build the future. Dwinov empowers creators and backers to bring bold projects into the world.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {[Twitter, Github, Linkedin, Instagram].map((Icon, i) => (
                <a key={i} href="#" className="grid place-items-center h-9 w-9 rounded-xl border border-warm-200 text-navy-600 hover:text-saffron-600 hover:border-saffron-200 transition-colors" aria-label="Social link">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {[
            { title: "Platform", links: [["Explore", "/explore"], ["Categories", "/categories"], ["Start campaign", "/start"], ["Pricing", "/pricing"]] },
            { title: "Company", links: [["About", "/about"], ["Contact", "/contact"], ["Careers", "#"], ["Press", "#"]] },
            { title: "Legal", links: [["Terms", "#"], ["Privacy", "#"], ["Trust", "#"], ["Cookies", "#"]] }
          ].map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm font-semibold text-navy-800">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <Link to={href} className="text-sm text-navy-500 hover:text-saffron-600 transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-warm-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-navy-500">© {new Date().getFullYear()} Dwinov Labs, Inc. Crafted for creators.</p>
          <p className="text-xs text-navy-500">Made with intent in San Francisco, Lisbon & Tokyo.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
